import React, { useEffect, useState } from "react";
import { PageSubHeader, usePageData } from "../../../provider/PageDataProvider";
import { getDashboardAuth } from "../../services/dashboard";
import FinanceDashboard from "./finance/financeReport/FinanceDashboard";
import SalesDashboard from "./sales/sales-report/SalesDashboard";
import ProcurementDashboard from "./inventory/procurement/procurement-report/ProcurementDashboard";
import InventoryDashboard from "./inventory/inventory-report/InventoryDashboard";
import ProductionDashboard from "./production/production-report/ProductionDashboard";
import CrmDashboard from "./crm/crm-report/CrmDashboard";
import UserDashboard from "./users/user-report/UserDashboard";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
import ContentLayout from "../../partials/content/ContentLayout";
import Illustration from "../../partials/content/Illustration";
export default function Dashboard() {
  const { reload } = useGlobalData();
  const [appCodeList, setAppCodeList] = useState([]);
  const [headerTitle, setHeaderTitle] = useState("Dashboard");
  const [component, setComponent] = useState(null);

  useEffect(() => {
    getDashboardAuthData();
  }, [reload]);

  const actionGroupButtons = [];
  if (appCodeList.length > 0) {
    appCodeList.map((appCode, index) => {
      if (appCode === "DAFN") {
        actionGroupButtons.push({
          title: "",
          tooltip: "Finance Dashboard",
          activeButton: headerTitle,
          color: "label-brand",
          activeColor: "brand",
          icon: "fas fa-money-bill-wave",
          onClick: () => {
            setComponent(<FinanceDashboard />);
            setHeaderTitle("Finance Dashboard");
          },
        });
      } else if (appCode === "DASL") {
        actionGroupButtons.push({
          title: "",
          tooltip: "Sales Dashboard",
          activeButton: headerTitle,
          color: "label-brand",
          activeColor: "brand",
          icon: "fas fa-store",
          onClick: () => {
            setComponent(<SalesDashboard />);
            setHeaderTitle("Sales Dashboard");
          },
        });
      } else if (appCode === "DAPC") {
        actionGroupButtons.push({
          title: "",
          tooltip: "Procurement Dashboard",
          activeButton: headerTitle,
          color: "label-brand",
          activeColor: "brand",
          icon: "fas fa-shopping-cart",
          onClick: () => {
            setComponent(<ProcurementDashboard />);
            setHeaderTitle("Procurement Dashboard");
          },
        });
      } else if (appCode === "DAIV") {
        actionGroupButtons.push({
          title: "",
          tooltip: "Inventory Dashboard",
          activeButton: headerTitle,
          color: "label-brand",
          activeColor: "brand",
          icon: "fas fa-boxes",
          onClick: () => {
            setComponent(<InventoryDashboard />);
            setHeaderTitle("Inventory Dashboard");
          },
        });
      } else if (appCode === "DAPD") {
        actionGroupButtons.push({
          title: "",
          tooltip: "Production Dashboard",
          activeButton: headerTitle,
          color: "label-brand",
          activeColor: "brand",
          icon: "fas fa-hard-hat",
          onClick: () => {
            setComponent(<ProductionDashboard />);
            setHeaderTitle("Production Dashboard");
          },
        });
      } else if (appCode === "DACR") {
        actionGroupButtons.push({
          title: "",
          tooltip: "CRM Dashboard",
          activeButton: headerTitle,
          color: "label-brand",
          activeColor: "brand",
          icon: "fas fa-people-arrows",
          onClick: () => {
            setComponent(<CrmDashboard />);
            setHeaderTitle("CRM Dashboard");
          },
        });
      } else if (appCode === "DAUS") {
        actionGroupButtons.push({
          title: "",
          tooltip: "User Dashboard",
          activeButton: headerTitle,
          color: "label-brand",
          activeColor: "brand",
          icon: "fas fa-user-friends",
          onClick: () => {
            setComponent(<UserDashboard />);
            setHeaderTitle("User Dashboard");
          },
        });
      }
    });
  }

  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle}
        breadcrumbs={[]}
        actionButtons={[]}
        actionGroupButtons={actionGroupButtons}
      />
      {component !== null ? (
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">{component}</div>
        </div>
      ) : (
        <ContentLayout>
          <Illustration
            imageSource="INVIFO CRM.png"
            description="Hooray! You're ready to explore the Dashboard!"
            guidance="Hint: make sure you have the dashboard authorization to get a better insight into the company"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        </ContentLayout>
      )}
    </React.Fragment>
  );

  async function getDashboardAuthData() {
    const response = await getDashboardAuth();
    setAppCodeList(response.data);
    const dashboards = response.data.filter(
      (dashboard) =>
        dashboard === "DAFN" ||
        dashboard === "DASL" ||
        dashboard === "DAPC" ||
        dashboard === "DAIV" ||
        dashboard === "DAPD" ||
        dashboard === "DACR" ||
        dashboard === "DAUS"
    );
    if (dashboards && dashboards.length > 0) {
      if (dashboards[0] === "DAFN") {
        setComponent(<FinanceDashboard />);
        setHeaderTitle("Finance Dashboard");
      } else if (dashboards[0] === "DASL") {
        setComponent(<SalesDashboard />);
        setHeaderTitle("Sales Dashboard");
      } else if (dashboards[0] === "DAPC") {
        setComponent(<ProcurementDashboard />);
        setHeaderTitle("Procurement Dashboard");
      } else if (dashboards[0] === "DAIV") {
        setComponent(<InventoryDashboard />);
        setHeaderTitle("Inventory Dashboard");
      } else if (dashboards[0] === "DAPD") {
        setComponent(<ProductionDashboard />);
        setHeaderTitle("Production Dashboard");
      } else if (dashboards[0] === "DACR") {
        setComponent(<CrmDashboard />);
        setHeaderTitle("CRM Dashboard");
      } else if (dashboards[0] === "DAUS") {
        setComponent(<UserDashboard />);
        setHeaderTitle("User Dashboard");
      }
    } else {
      setHeaderTitle("Dashboard");
    }
  }
}
